import type { VideoLink } from './types';

/* Ссылка на видео с видеохостинга (VID-3): тренер вставляет адрес ролика — клиент открывает его на самом хостинге.
   Узнаём хостинг по адресу, чтобы подписать кнопку («Смотреть на YouTube»); любая другая https-ссылка тоже годится. */

const HOSTS: [RegExp, string][] = [
  [/(^|\.)(youtube\.com|youtu\.be|youtube-nocookie\.com)$/, 'YouTube'],
  [/(^|\.)rutube\.ru$/, 'Rutube'],
  [/(^|\.)(vk\.com|vk\.ru|vkvideo\.ru|vk\.video)$/, 'VK Видео'],
  [/(^|\.)dzen\.ru$/, 'Дзен'],
  [/(^|\.)vimeo\.com$/, 'Vimeo'],
  [/(^|\.)kinescope\.io$/, 'Kinescope'],
  [/(^|\.)(instagram\.com|instagr\.am)$/, 'Instagram'],
  [/(^|\.)tiktok\.com$/, 'TikTok'],
  [/(^|\.)(t\.me|telegram\.me)$/, 'Telegram'],
  [/(^|\.)(disk\.yandex\.ru|disk\.yandex\.com|yadi\.sk)$/, 'Яндекс Диске'],
  [/(^|\.)(drive\.google\.com)$/, 'Google Диске'],
];

/** Разбор вставленного текста: первая http(s)-ссылка в нём (можно вставить вместе с подписью) → ссылка на видео; не ссылка — null */
export function videoLink(input: string): VideoLink | null {
  const m = String(input || '').match(/https?:\/\/[^\s<>"']+|(?:^|\s)((?:www\.|m\.)?(?:youtube\.com|youtu\.be|rutube\.ru|vk\.com|vkvideo\.ru|dzen\.ru|vimeo\.com|instagram\.com|tiktok\.com|t\.me)\/[^\s<>"']+)/i);
  if (!m) return null;
  let raw = (m[1] || m[0]).trim().replace(/[),.;!?»]+$/, '');
  if (!/^https?:\/\//i.test(raw)) raw = 'https://' + raw;
  let u: URL;
  try {
    u = new URL(raw);
  } catch {
    return null;
  }
  if (!/^https?:$/.test(u.protocol) || !u.hostname.includes('.')) return null;
  const h = u.hostname.toLowerCase().replace(/^www\./, '');
  const host = HOSTS.find(([re]) => re.test(h))?.[1] || h;
  return { url: u.toString().slice(0, 500), host };
}

/** Подпись кнопки: «Смотреть на YouTube» / «Смотреть на Яндекс Диске» / «Смотреть на site.ru» */
export const linkLabel = (l: VideoLink) => 'Смотреть на ' + l.host;
